import React from 'react'; 
import { Button, Checkbox, FormControlLabel, TextField } from '@mui/material';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { LanguageReq } from '../types/language';

const schema = Yup.object().shape({
  name: Yup.string().required(),
  code: Yup.string().required(),
  isActive: Yup.boolean(),
  isRtl: Yup.boolean(),
});

export const LanguageForm = ({ initialValues, onSubmit }: {
  initialValues: LanguageReq;
  onSubmit: (values: LanguageReq) => void;
}) => (
  <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={schema}>
    {({ values, handleChange }) => (
      <Form>
        <TextField name="name" label="Name" value={values.name} onChange={handleChange} fullWidth />
        <TextField name="code" label="Code" value={values.code} onChange={handleChange} fullWidth />
        <FormControlLabel control={<Checkbox name="isActive" checked={values.isActive} onChange={handleChange} />} label="Active" />
        <FormControlLabel control={<Checkbox name="isRtl" checked={values.isRtl} onChange={handleChange} />} label="RTL" />
        <Button type="submit" variant="contained">Save</Button>
      </Form>
    )}
  </Formik>
);